import { render, staticRenderFns } from "./CabeceraLogin.vue?vue&type=template&id=d034885c&scoped=true&functional=true&"
var script = {}
import style0 from "./CabeceraLogin.vue?vue&type=style&index=0&id=d034885c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "d034885c",
  null
  
)

export default component.exports